module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "sink"
  }, [_c('p', {
    staticClass: "left "
  }, [_vm._v("For it is the bitter grief of theology and its blessed task, too, always to have to seek (because it does not clearly have present to it at the time) what in a true sense—in its historical memory—it has always known . . . always providing that one has the courage to ask questions, to be dissatisfied, to think with the mind and heart one actually has, and not with the mind and heart one is supposed to have.")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "right "
  }, [_vm._v("—Karl Rahner, S.J.")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-116f0f86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front03.vue
// module id = 66
// module chunks = 0